export enum PromoType {
  CASINO = "CASINO",
  F2P = "F2P",
  NONE = "NONE",
}

export enum Sport {
  soccer = "soccer",
  basketball = "basketball",
  mma = "mma",
}

export enum GameType {
  MysteryBox = "MYSTERY_BOX",
  Penalty = "PENALTY",
  Wheel = "WHEEL",
}
